import * as React from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import TDrawerHeader from "./TDrawerHeader";
import TDrawerContent from "./TDrawerContent";

class TDrawerForm extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        open: PropTypes.bool,
        showSaveBtnBool: PropTypes.bool,
        title: PropTypes.string,
        onClose: PropTypes.func,
        headerVisible: PropTypes.bool,
    };

    static defaultProps = {
        open: false,
        showSaveBtnBool: true,
        title: "",
        onClose: () => console.log("onClose"),
        headerVisible: true,
    };

    constructor(props) {
        super(props);

        this.childSave = () => {};

        this.state = {
            modalVisible: false,
            drawerWidth: "70%",
            expanded: false,
        };
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onCloseBtnClick = () => {
        this.props.onClose("");
    };

    onSaveBtnClick = () => {
        this.childSave(() => {
            this.props.onClose("");
        });
    };

    onHelpBtnClick = () => {
        alert("Unavailable");
    };

    onMinimizeBtnClick = () => {
        this.setState({
            drawerWidth: "70%",
            expanded: false,
        });
    };

    onMaximizeBtnClick = () => {
        this.setState({
            drawerWidth: "100%",
            expanded: true,
        });
    };

    acceptMethods = (saveMethod) => {
        this.childSave = saveMethod;
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        const styles = {
            drawer: {
                width: this.state.drawerWidth,
                top: 0,
                bottom: 0,
                height: "auto",
            },
            content: {
                top: this.props.headerVisible ? 66 : 0,
            },
        };

        return (
            <Drawer
                anchor="right"
                open={this.props.open}
                PaperProps={{ style: { ...styles.drawer } }}
                ModalProps={{ disableBackdropClick: true }}
            >
                {this.props.headerVisible ? (
                    <TDrawerHeader
                        title={this.props.title}
                        expanded={this.state.expanded}
                        showSaveBtnBool={this.props.showSaveBtnBool}
                        onClose={this.onCloseBtnClick}
                        onSave={this.onSaveBtnClick}
                        onHelp={this.onHelpBtnClick}
                        onMinimize={this.onMinimizeBtnClick}
                        onMaximize={this.onMaximizeBtnClick}
                    />
                ) : null}

                <TDrawerContent style={styles.content}>
                    {this.props.children !== null
                        ? React.cloneElement(this.props.children, { shareMethods: this.acceptMethods })
                        : null}
                </TDrawerContent>
            </Drawer>
        );
    }
}

export default TDrawerForm;
